import { BehaviorSubject, Subject } from "rxjs";
import { IConfirmationConfig } from "../models/confirmation.model";
import { IAttachment, ITableWrapperRefreshSubject } from "../models/common.model";

const logoutSubject: Subject<void> = new Subject();
const updateLoginUserTokenSubject: Subject<string | undefined> = new Subject<string | undefined>()
const updateActiveUserIdSubject: Subject<string> = new Subject<string>();
const NetworkChangeSubject: Subject<boolean> = new Subject<boolean>();
const ReloadStateSubject: Subject<void> = new Subject<void>();
const RestrictedAccessSubject: Subject<boolean> = new Subject<boolean>();
const PageLoadingStateSubject: Subject<boolean> = new Subject<boolean>();
const LightBoxSubject: Subject<IAttachment[]> = new Subject<IAttachment[]>();
const sendMessageSubject: Subject<{ message: string, type?: string }> = new Subject<{ message: string, type?: string }>();
const elevenLabsSendMessageSubject: Subject<{ message: string, type?: string }> = new Subject<{ message: string, type?: string }>();
const requirementsGatheringCompletedSubject: Subject<{ message: string, type?: string }> = new Subject<{ message: string, type?: string }>();
const onErrorFixedSubject: Subject<void> = new Subject<void>();
const fetchChatHistorySubject: Subject<void> = new Subject<void>();
const triggerErrorCardSubject: Subject<{ error: string; timestamp?: string; projectId?: string }> = new Subject<{ error: string; timestamp?: string; projectId?: string }>();
const clearPreviewErrorsSubject: Subject<void> = new Subject<void>();

const TableWrapperRefreshSubject: Subject<ITableWrapperRefreshSubject> = new Subject<ITableWrapperRefreshSubject>();


const DialogStateSubject: Subject<{
    component: any,
    promise: {
        resolve: any,
        reject: any
    }
}> = new Subject<{
    component: any;
    promise: {
        resolve: any;
        reject: any
    }
}>()

const SetUserColorScheme: Subject<'light' | 'dark'> = new Subject<'light' | 'dark'>();
const ConfirmStateSubject: Subject<{
    config: IConfirmationConfig,
    promise: {
        resolve: any,
        reject: any
    }
}> = new Subject<{
    config: IConfirmationConfig;
    promise: {
        resolve: any;
        reject: any
    }
}>()
const pageBackButtonSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
const pageTitleSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
const connectSupabaseSubject: BehaviorSubject<any | null> = new BehaviorSubject<any | null>(null);
const supabaseConnectedSuccessSubject: Subject<void> = new Subject<void>();
const reloadPreviewSubject: Subject<string | null> = new Subject<string | null>(); // Changed from BehaviorSubject to Subject to prevent immediate emission on subscribe

const handleCodeStreamerSubject: Subject<any> = new Subject<any>();
const handlePmResponseStreamerSubject: Subject<any> = new Subject<any>();
const endCodeStreamerSubject: Subject<boolean> = new Subject<boolean>();
const startCodeStreamerSubject: Subject<boolean> = new Subject<boolean>();
const switchCodeAndPreviewSubject: Subject<boolean> = new Subject<boolean>();
const toggleFileUploadSubject: Subject<boolean> = new Subject<boolean>();
const fetchProjectCode: Subject<boolean> = new Subject<boolean>();
const scrollToBottomOfChatSubject: Subject<boolean> = new Subject<boolean>();
const triggerGrapesJSSaveSubject: Subject<{ htmlContent: string; cssContent?: string; commitMessage?: string }> = new Subject<{ htmlContent: string; cssContent?: string; commitMessage?: string }>();
const triggerCommitDialogSubject: Subject<boolean> = new Subject<boolean>();
const switchToChatTabSubject: Subject<void> = new Subject<void>();
const openSettingsSubject: Subject<{ category?: string }> = new Subject<{ category?: string }>();
const closeSettingsSubject: Subject<void> = new Subject<void>();
const showUpgradeOrTopupDialogSubject: Subject<{ message?: string }> = new Subject<{ message?: string }>();
const retryChatMessageSubject: Subject<{ retryMessage: boolean }> = new Subject<{ retryMessage: boolean }>();
const aiConcurrencyErrorSubject: Subject<{ error: string; timestamp?: string }> = new Subject<{ error: string; timestamp?: string }>();
const advancedModeErrorSubject: Subject<{ error: string; timestamp?: string }> = new Subject<{ error: string; timestamp?: string }>();
const setPreviewLoadingStateSubject: Subject<boolean> = new Subject<boolean>();
const setAdvancedModePreviewLoadingSubject: Subject<boolean> = new Subject<boolean>();
const setProjectUrlSubject: Subject<string> = new Subject<string>();

const Communications = {
    logoutSubject,
    updateActiveUserIdSubject,
    updateLoginUserTokenSubject,
    NetworkChangeSubject,
    ReloadStateSubject,
    SetUserColorScheme,
    PageLoadingStateSubject,
    pageBackButtonSubject,
    pageTitleSubject,
    ConfirmStateSubject,
    DialogStateSubject,
    LightBoxSubject,
    TableWrapperRefreshSubject,
    sendMessageSubject,
    elevenLabsSendMessageSubject,
    requirementsGatheringCompletedSubject,
    onErrorFixedSubject,
    fetchChatHistorySubject,
    connectSupabaseSubject,
    supabaseConnectedSuccessSubject,
    reloadPreviewSubject,
    handleCodeStreamerSubject,
    handlePmResponseStreamerSubject,
    endCodeStreamerSubject,
    startCodeStreamerSubject,
    switchCodeAndPreviewSubject,
    RestrictedAccessSubject,
    toggleFileUploadSubject,
    fetchProjectCode,
    scrollToBottomOfChatSubject,
    triggerErrorCardSubject,
    clearPreviewErrorsSubject,
    triggerGrapesJSSaveSubject,
    triggerCommitDialogSubject,
    switchToChatTabSubject,
    openSettingsSubject,
    closeSettingsSubject,
    showUpgradeOrTopupDialogSubject,
    retryChatMessageSubject,
    aiConcurrencyErrorSubject,
    advancedModeErrorSubject,
    setPreviewLoadingStateSubject,
    setAdvancedModePreviewLoadingSubject,
    setProjectUrlSubject
};

export default Communications;